/*
 * Public API Surface of ds-lib-common
 */
/** I18n */
import * as pl from './assets/i18n/pl.json';
import * as fr from './assets/i18n/fr.json';
import * as en from './assets/i18n/en.json';
import * as es from './assets/i18n/es.json';
import * as cs from './assets/i18n/cs.json';

export const TRANSLATIONS = { fr, en, es, cs, pl };

/** Modules */
export * from './lib/ds-lib-common.module';
export * from './shared/ds-lib-shared.module';
export * from './shared/ds-lib-material.module';
export * from './lib/components/ds-confirm-dialog/ds-confirm-dialog.module';

/** Components */
export * from './lib/components/ds-lib-search-bar/index';
export * from './lib/components/ds-lib-search-autocomplete/index';
export * from './lib/components/ds-lib-profile-bar/index';
export * from './lib/components/ds-lib-language-picker/index';
export * from './lib/components/ds-lib-list/index';
export * from './lib/components/ds-lib-list-with-actions/index';
export * from './lib/components/ds-lib-icon-card/index';
export * from './lib/components/ds-lib-hover/index';
export * from './lib/components/ds-lib-file-select/index';
export * from './lib/components/dividers/ds-lib-vertical-divider/index';
export * from './lib/components/ds-lib-checkbox-table/index';
export * from './lib/components/snackbars/ds-lib-snackbar/index';
export * from './lib/components/ds-charts/index';
export * from './lib/components/ds-lib-help/index';
export * from './lib/components/byd-confirm-dialog/index';
export * from './lib/components/byd-alert/index';
export * from './lib/components/ds-confirm-dialog/ds-confirm-dialog.component';
export * from './lib/components/byd-validations/index';

/** Enums */
export * from './shared/enums/index';

/** Services */
export * from './shared/services/index';

/** Validators */
export * from './shared/validators/index';

/** Interfaces */
export * from './shared/interfaces/index';
export * from './lib/interfaces/index';

/** Pipes */
export * from './lib/pipes';

/** Guards */
export * from './lib/guards/index';

/** Models */
export * from './lib/models/index';
